import { TZDate } from '@date-fns/tz';
import { endOfDay, format, parse } from 'date-fns';
import _compact from 'lodash/compact';
import _uniq from 'lodash/uniq';
import validator from 'validator';

import { checkValidDate } from '@/utils/date';
import * as dateHelpers from '@/helpers/date';

export function getQueryStringValue(
  queryValue?: unknown,
  _defQueryValue?: string,
): string | undefined {
  if (typeof queryValue !== 'string') return _defQueryValue;
  const value = queryValue;
  if (value.length > 0) return value;
  return _defQueryValue;
}

export function getQueryNumberValue(
  queryValue?: unknown,
  _defQueryValue?: number,
): number | undefined {
  if (typeof queryValue !== 'string') return _defQueryValue;
  const value = parseInt(queryValue);
  if (Number.isNaN(value)) return _defQueryValue;
  if (value >= 0) return value;
  return _defQueryValue;
}

export function getQueryDateValue(
  queryValue?: unknown,
  _defQueryValue?: Date,
): Date | undefined {
  if (typeof queryValue === 'string' && queryValue.length > 0) {
    const _queryValue = new Date(Date.parse(queryValue + 'T00:00:00.000'));
    if (checkValidDate(_queryValue)) return _queryValue;
  }
  return _defQueryValue;
}

export function getApiZonedQueryDateValue(
  queryValue?: unknown,
  _defQueryValue?: TZDate,
): TZDate | undefined {
  if (typeof queryValue === 'string' && queryValue.length === 10) {
    const _queryValue: TZDate = endOfDay(
      parse(
        queryValue,
        'yyyy-MM-dd',
        TZDate.tz(dateHelpers.defaultApiTimeZone),
      ),
    );
    if (
      checkValidDate(_queryValue) &&
      format(_queryValue, 'yyyy-MM-dd') === queryValue
    ) {
      return _queryValue;
    }
  }
  return _defQueryValue;
}

export function getQueryStringListValue(
  queryValue?: unknown,
  _defQueryValue?: string[],
): string[] | undefined {
  if (typeof queryValue === 'string') {
    if (queryValue.length > 0) {
      // TODO
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      const _queryValue = queryValue?.split(',');
      if (_queryValue.length) return _queryValue;
    }
    if (queryValue.length === 0) {
      return [];
    }
  }
  return _defQueryValue;
}

export function getQueryNumberListValue(
  queryValue?: unknown,
  _defQueryValue?: number[],
): number[] | undefined {
  if (typeof queryValue === 'string') {
    if (queryValue.length > 0) {
      let _queryValue = _uniq(
        _compact(queryValue.split(',').map((jobId) => parseInt(jobId))),
      ).filter((jobId) => jobId >= 0);
      _queryValue = [..._queryValue].sort(undefined);
      if (_queryValue.length) return _queryValue;
    }
    if (queryValue.length === 0) {
      return [];
    }
  }
  return _defQueryValue;
}

export function getQueryDatePairValue(
  queryValue?: unknown,
  _defQueryValue?: [Date, Date],
): [Date, Date] | undefined {
  let firstDate;
  let lastDate;
  if (typeof queryValue === 'string' && queryValue.length > 0) {
    // TODO
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const _queryValue = queryValue?.split(',');
    firstDate = getQueryDateValue(_queryValue[0], _defQueryValue?.[0]);
    lastDate = getQueryDateValue(_queryValue[1], _defQueryValue?.[1]);
    if (firstDate && lastDate) return [firstDate, lastDate];
  }
  firstDate = getQueryDateValue(undefined, _defQueryValue?.[0]);
  lastDate = getQueryDateValue(undefined, _defQueryValue?.[1]);
  if (firstDate && lastDate) return [firstDate, lastDate];
  return undefined;
}

export function getQueryBooleanValue(
  queryValue?: unknown,
  _defQueryValue?: boolean,
): boolean | undefined {
  if (typeof queryValue !== 'string') return _defQueryValue;
  return validator.toBoolean(queryValue);
}
